import {
  IxEventType,
  ParsedOrderJson,
  ParseNotificationResult,
  QuickTradeNotificationData,
} from '@sdk/notification/types';

interface ChatJson {
  id: number;
  text: string;
  attachments: string[];
  sender: `0x${string}`;
  receiver: `0x${string}`;
  orderId: `0x${string}`;
  createdAt: string;
}

export type IEXNote = 'quickTrade' | 'kyc' | 'chat' | 'order' | 'none';

interface OrderJson {
  orderHash: `0x${string}`;
  state: string;
  quickTradeId: string;
}

interface RawNotification {
  id?: string;
  data?: string | { json?: string };
  messageId?: string;
  addressId?: string;
  title?: string;
  body?: string;
  notification?: { title?: string; body?: string };
  red?: boolean;
}

export function parseNotificationData(
  raw: RawNotification,
  noteType: IEXNote,
): ParseNotificationResult | null {
  console.log('parsingNotificationData', raw, noteType);
  try {
    const json =
      typeof raw.data === 'string'
        ? JSON.parse(raw.data)
        : typeof raw.data?.json === 'string'
        ? JSON.parse(raw.data.json)
        : {};

    const createdAt = json.createdAt ?? new Date().toISOString();
    const id = raw.id ?? crypto.randomUUID();

    switch (noteType) {
      case IxEventType.QUICK_TRADE:
        return json as QuickTradeNotificationData;

      case 'chat':
        const chatJson = json as ChatJson;
        return {
          id: chatJson.id,
          text: chatJson.text,
          attachments: chatJson.attachments || [],
          sender: chatJson.sender,
          receiver: chatJson.receiver,
          orderId: chatJson.orderId,
          createdAt,
        };

      case IxEventType.ORDER:
        const orderJson = json as OrderJson;
        return {
          id,
          from: '776258925896',
          messageId: raw.messageId,
          quickTradeId: json.quickTradeId,
          title: raw.title ?? raw.notification?.title ?? noteType.toUpperCase(),
          body: raw.body ?? raw.notification?.body ?? json.text ?? '',
          note: noteType,
          orderHash: json.orderId ?? json.orderHash ?? '',
          state: json.state ?? '',
          red: !!raw.red,
          createdAt: new Date(createdAt),
        };

      default:
        return json;
    }
  } catch (err) {
    console.error('❌ Failed to parse notification data:', err);
    return null;
  }
}
